import { render, staticRenderFns } from "./ComponentsLog.vue?vue&type=template&id=53823560&"
import script from "./ComponentsLog.vue?vue&type=script&lang=js&"
export * from "./ComponentsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53823560')) {
      api.createRecord('53823560', component.options)
    } else {
      api.reload('53823560', component.options)
    }
    module.hot.accept("./ComponentsLog.vue?vue&type=template&id=53823560&", function () {
      api.rerender('53823560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/ComponentsLog.vue"
export default component.exports